import React, { useEffect, useRef } from "react";

import Layout from "../../../layout/Layout";
import {
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControl,
  InputLabel,
} from "@mui/material";

import { useState } from "react";
import {
  config,
  termsAndConditionsAPI,
  termsAPI,
  termsUpdateAPI,
} from "../../../config";
import { termsTypeList } from "../../../components/constants";
import axios from "axios";
import { AlertMessage } from "../../../components/AlertMessage";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";
import * as Yup from "yup";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Editor styles

import { apiData } from "../../../services/api_service";
import { Backdrop, CircularProgress } from "@mui/material";

function TermsConditions() {
  const { termsID } = useParams();

  const childRef = useRef();

  const navigate = useNavigate();
  const { orderType } = useParams();

  const [isDefault, setIsDefault] = useState(!termsID);
  const [loading, setLoading] = useState(false);
  const [txtTitle, setTitle] = useState("");
  const [errors, setErrors] = useState({});

  const validationSchema = Yup.object().shape({
    txtTitle: Yup.string().required("Title is required"),
  });

  const handleSubmit = async () => {
    // Validation
    try {
      await validationSchema.validate(
        { txtTitle }, 
        { abortEarly: false }
      );
      setErrors({});
    } catch (validateError) {
      const validationErrors = {};
      validateError.inner.forEach((err) => {
        validationErrors[err.path] = err.message;
      });
      setErrors(validationErrors);
      console.error("Validation error:", validateError);
      return;
    }

    try {
      setLoading(true);
      const user = JSON.parse(localStorage.getItem("user"));

      const data = {
        termsType: orderType === "purchase" ? 1 : 2,
        title: txtTitle,
        terms: terms,
        user_id: user.emp_id,
        isDefault: isDefault ? 1 : 0,
      };

      let result;

      if (termsID) {
        data.id = termsID;
        data.status = status;
        result = await apiData("post", termsUpdateAPI, data);
      } else {
        result = await apiData("post", termsAPI, data);
      }

      if (result.success) {
        childRef.current.triggerAlert(
          JSON.stringify({
            message:
              result.message ||
              (termsID
                ? "Terms & Conditions updated successfully"
                : "Terms & Conditions added successfully"),
            messageType: "success",
          })
        );
        setTimeout(() => {
          navigate(`/terms/list/${orderType}`);
        }, 1000);
      } else {
        childRef.current.triggerAlert(
          JSON.stringify({
            message:
              result.message || "Error while saving Terms and Conditions",
            messageType: "error",
          })
        );
      }
    } catch (error) {
      childRef.current.triggerAlert(
        JSON.stringify({
          message: error.msg,
          messageType: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (termsID) {
      fetchTermsDetails();
    }
  }, [termsID]);
  
  const fetchTermsDetails = async () => {
    try {
      const response = await apiData("get", `${termsAndConditionsAPI}`, {
        id: termsID,
      });
      if (response.data.result[0]) {
        setTitle(response.data.result[0].title);
        setTerms(response.data.result[0].description);
        setIsDefault(response.data.result[0].isDefault === 1);
      }
    } catch (error) {
      console.error("Error fetching Terms & Conditions details:", error);
    }
  };
  const [terms, setTerms] = useState("");
  const [status, setStatus] = useState(1);

  const statusList = [
    { id: 1, name: "Active" },
    { id: 0, name: "Inactive" },
  ];

  return (
    <Layout>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <AlertMessage ref={childRef} />
      <Grid className="employee-form bold-header">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              {orderType === "purchase" ? "Purchase Order" : "Invoice"} -
              Terms & Conditions
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Terms & Conditions</Typography>
              <Typography color="text.primary">Add</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <LoadingButton
              size="medium"
              variant="contained"
              color="secondary"
              className="button_first"
              href={`/terms/list/${orderType}`}
            >
              List Terms and Conditions
            </LoadingButton>
            <LoadingButton
              size="medium"
              variant="contained"
              color="primary"
              onClick={() => navigate(-1)}
              startIcon={<ArrowBackIosIcon />}
            >
              Back
            </LoadingButton>
          </Grid>
        </Grid>

        <Grid className="form_design">
          <Grid container spacing={2}>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              textAlign={`right`}
              display={`flex`}
              justifyContent={`flex-end`}
            >
              <TextField
                fullWidth
                onChange={(e) => setTitle(e.target.value)}
                label="Title"
                value={txtTitle}
                error={errors.txtTitle ? true : false}
                helperText={errors.txtTitle ? errors.txtTitle : ""}
              />
            </Grid>

            <Grid item lg={12} md={12} sm={12} mt={2}>
              <ReactQuill
                theme="snow"
                value={terms}
                onChange={(content) => setTerms(content)}
              />
            </Grid>

            <Grid item lg={6} md={6} sm={12} mt={2}>
              <FormControl fullWidth>
                <InputLabel id="status-label">Status</InputLabel>
                <Select
                  labelId="status-label"
                  id="status-select"
                  label="Status"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  {statusList.map((row) => (
                    <MenuItem key={row.id} value={row.id}>
                      {row.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              mt={2}
              display="flex"
              alignItems="center"
            >
              <Checkbox
                checked={isDefault}
                onChange={(e) => setIsDefault(e.target.checked)}
              />
              <Typography fontSize={16}>
                Set as default Terms & Condition
              </Typography>
            </Grid>

            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              textAlign={`right`}
              display={`flex`}
              justifyContent={`center`}
            >
              <Button
                variant="primary"
                className={`btn-primary`}
                onClick={handleSubmit}
                disabled={loading}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default TermsConditions;
